var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99725 5V14.5875L7.71078 12.2987C7.32117 11.9087 6.68181 11.9087 6.29221 12.2987C5.9026 12.6887 5.9026 13.3187 6.29221 13.7087L10.287 17.7075C10.6766 18.0975 11.3059 18.0975 11.6955 17.7075L15.7078 13.7113C16.0974 13.3213 16.0974 12.6913 15.7078 12.3013C15.3182 11.9113 14.6888 11.9113 14.2992 12.3013L11.9952 14.5875V5C11.9952 4.45 11.5457 4 10.9962 4C10.4468 4 9.99725 4.45 9.99725 5Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/ArrowDownIcon.1bf838786cadadd7cbd7bb3cee409d26.svg";
export { ForwardRef as ReactComponent };